const DEBUG_CART_DISCOUNTS = true;

function debug(...args) {
  if (DEBUG_CART_DISCOUNTS) {
    console.log('[CartDiscounts]', ...args);
  }
}

/**
 *  @class
 *  @function CartDiscounts
 */
if (!customElements.get('cart-discounts')) {
  class CartDiscounts extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {
      debug('connected');
      this.discounts();
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      }, {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    discounts() {
      const button = document.getElementById('cart-discount-submit');
      const remove_discount_buttons = this.querySelectorAll('.cart-discounts--remove')

      if (!button) {
        debug('error', 'button not found!');
        return;
      }

      if (button.dataset.listenerAttached) {
        debug('listener already attached');
        return;
      }
      button.dataset.listenerAttached = 'true';

      button.addEventListener('click', (event) => {
        try {
          event.preventDefault();          
          debug('Apply clicked');
          if (button.classList.contains('loading')) {
            debug('warning', 'Already loading');
            return;
          }
          button.classList.add('loading');
          this.updateDiscount();
        } catch (error) {
          debug('error', error);
          button.classList.remove('loading');
        }
      });
      remove_discount_buttons.forEach((remove_discount_button) => {
        remove_discount_button.addEventListener('click', this.removeDiscount.bind(this));
      });
    }
    updateDiscount() {
      const discountCode = document.getElementById('cart-discount');
      const discountCodeValue = discountCode.value.trim();
      if (!discountCodeValue) {
        debug('warning','Empty discount code');
        document.getElementById('cart-discount-submit')?.classList.remove('loading');
        return;
      }
      debug('Discount code', discountCodeValue);

      const existingDiscounts = this.existingDiscounts();
      if (existingDiscounts.includes(discountCodeValue)) {
        document.getElementById('cart-discount-submit')?.classList.remove('loading');
        return
      };

      existingDiscounts.push(discountCodeValue);
      this.renderDiscounts(existingDiscounts, discountCodeValue);
    }
    removeDiscount(event) {
      const pill = event.target.previousElementSibling;
      const discountCode = pill.innerHTML;
      const existingDiscounts = this.existingDiscounts();
      const index = existingDiscounts.indexOf(discountCode);
      if (index === -1) return;

      existingDiscounts.splice(index, 1);

      this.renderDiscounts(existingDiscounts);
    }
    existingDiscounts() {
      const discountCodes = [];
      const discountPills = this.querySelectorAll('.cart-discounts--name');
      for (const pill of discountPills) {
        discountCodes.push(pill.innerHTML);
      }

      return discountCodes;
    }
    renderDiscounts(existingDiscounts, discountCodeValue) {
      const body = JSON.stringify({
        discount: existingDiscounts.join(','),
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });
      this.querySelector('.cart-discounts--error')?.setAttribute('hidden', '');
      this.querySelector('.cart-discounts--input')?.classList.remove('error');

      // Remember which cart container this form lives in. Re-rendering the
      // sections below replaces this element, so we need to re-target the
      // freshly rendered <cart-discounts> afterwards.
      const container = this.closest('#Cart-Drawer, #Cart');

      debug('update', body);
      fetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      })
        .then((response) => {
          debug('Response', response);
          if (!response.ok) {
            throw new Error(
              `Request failed: ${response.status}`
            );
          }
          return response.text();
        })
        .then((state) => {
          let parsedState;
          try {
            parsedState = JSON.parse(state);
          } catch (error) {
            debug('error', 'Invalid JSON response', state);
            throw error;
          }

          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);

            if (parsedState.sections && elementToReplace) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }
          }));

          // `this` is now detached from the DOM - grab the re-rendered element.
          const cartDiscounts = container?.querySelector('cart-discounts') || this;
          cartDiscounts.querySelector('.cart-discounts--button')?.classList.remove('loading');

          if (parsedState.discount_codes.find((discount) => {
            return discount.code === discountCodeValue && discount.applicable === false;
          })) {
            // Keep the discount accordion open so the error stays visible -
            // an invalid code applies nothing, so the section re-renders it closed.
            const details = cartDiscounts.closest('collapsible-row')?.querySelector('details');
            if (details) details.open = true;

            // Restore the rejected code so the customer can correct it.
            const input = cartDiscounts.querySelector('.cart-discounts--input');
            if (input) {
              input.value = discountCodeValue;
              input.classList.add('error');
            }

            setTimeout(() => {
              cartDiscounts.querySelector('.cart-discounts--error').removeAttribute('hidden');
            }, 300);
          }
        })
        .catch((error) => {
          debug('error','Fetch error', error);
          document.getElementById('cart-discount-submit')?.classList.remove('loading');
        })
        .finally(() => {
          document.getElementById('cart-discount-submit').classList.remove('loading');
        });
    }
  }
  customElements.define('cart-discounts', CartDiscounts);
} else {
  debug('error','!customElements.get(cart-discounts):', !customElements.get('cart-discounts'));
}